<template>
    <div>
        <h1>{{ $t("admin.adminUserView.header") }}</h1>
        <form id="search" @submit="updateUser">
            <label for="emailAddress">{{ $t("admin.adminUserView.emailAddress") }}: </label><input id="emailAddress" name="emailAddress" v-model="userData.appUserInfo.emailAddress"><br/>
            <label for="givenName">{{ $t("admin.adminUserView.givenName") }}: </label><input id="givenName" name="givenName" v-model="userData.appUserInfo.givenName"><br/>
            <label for="familyName">{{ $t("admin.adminUserView.familyName") }}: </label><input id="familyName" name="familyName" v-model="userData.appUserInfo.familyName"><br/>
            <label for="enabled">{{ $t("admin.adminUserView.enabled") }}: </label><input id="enabled" name="enabled" v-model="userData.appUserInfo.enabled" type="checkbox"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminUserView.button.update')">
        </form>
        <AdminUserDelete v-bind:userId="this.$route.params.userId" />
        <router-link :to="'/admin/planCreate/' + this.$route.params.userId">{{ $t("admin.adminUserView.link.create") }}</router-link><br/>
        <hr/>
        <h2>{{ $t("admin.adminUserView.auditLogsByUser") }}</h2>
        <AdminAuditLogList :attrs="{'actorId': this.$route.params.userId}"></AdminAuditLogList>
        <hr/>
        <h2>{{ $t("admin.adminUserView.auditLogsAboutUser") }}</h2>
        <AdminAuditLogList :attrs="{'appUserId': this.$route.params.userId}"></AdminAuditLogList>

    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import AdminUserDelete from "./AdminUserDelete";
    import AdminAuditLogList from "./AdminAuditLogList";

    export default {
        name: 'AdminUserView',
        components: {
            AdminUserDelete,
            AdminAuditLogList
        },
        data: function() {
            return {
                userData: {
                    appUserInfo: {
                        emailAddress: '',
                        givenName: '',
                        familyName: '',
                        enabled: false
                    }
                },
                myAuditLogs: [],
                aboutMeAuditLogs: []
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.userGet(this.$route.params.userId).then((data) => {
                    this.userData = data;
                }).catch((err) => {
                    console.error('Unable to get user: ', err)
                });
            },
            updateUser: function(e) {
                e.preventDefault();
                adminService.userUpdate(this.$route.params.userId, this.userData.appUserInfo).then((data) => {
                    console.log(data);
                }).catch((err) => {
                    console.error('Unable to update user: ', err)
                });
            }
        }
    }
</script>
